<template>
  <span class="icon"><i class="fa fa-wrapper fa-spinner fa-pulse"></i></span>
</template>
<style></style>
<script>
module.exports = {
  name: "loading-spinner"
};
</script>
